import React from 'react';
import { ContactHero } from '../components/contact/ContactHero';
import { BackButton } from '../components/common/BackButton';

export function ContactPage() {
  return (
    <div className="pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        <BackButton label="Back" />
      </div>
      <ContactHero />
    </div>
  );
}